import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './meeting-dashboard.constants';
import * as types from './meeting-dashboard.types';
import * as services from './meeting-dashboard.saga-services';

function* invokeInitialMeetingDashboard(action: types.IInitialMeetingDashboardPage) {
  yield call(services.initialMeetingDashboardPage, action.payload);
}

function* invokeTeamFileCreateFolderMeetingDashboardPage(action: types.IMeetingShortcutsCreateFolderDashboardPage) {
  yield call(
    services.teamFileCreateFolderMeetingDashboardPage,
    action.payload.meetingId,
    action.payload.name,
    action.payload.parentId,
  );
}

function* invokeMeetingShortcutSelectedFolderMeetingDashboardPage(
  action: types.IMeetingShortcutsSelectedFolderDashboardPage,
) {
  yield call(services.teamFileSelectionFolderMeetingDashboardPage, action.payload.meetingId, action.payload.folder);
}

function* invokeTeamFileOnDeselectFolderMeetingDashboardPage(
  action: types.IMeetingShortcutsOnDeselectFolderDashboardPage,
) {
  yield call(services.teamFileUnSelectionFolderMeetingDashboardPage, action.payload.meetingId);
}

function* invokeTeamFileDeleteFileDashboard(action: types.IMeetingShortcutDeleteFileDashboardPage) {
  yield call(services.teamFilesDeleteFileMeetingDashboardPage, action.payload.meetingId, action.payload.fileFolderId);
}

function* invokeTeamFileCreateFileDashboard(action: types.IMeetingShortcutsCreateFileDashboardPage) {
  yield call(
    services.teamFileCreateFileMeetingDashboardPage,
    action.payload.meetingId,
    action.payload.externalLink,
    action.payload.description,
    action.payload.folderId,
    action.payload.name,
  );
}

function* invokeMeetingShortcutUpdate(action: types.IMeetingShortcutUpdate) {
  yield call(
    services.meetingShortcutUpdate,
    action.payload.id,
    action.payload.data.meetingId,
    action.payload.data.externalLink,
    action.payload.data.description,
    action.payload.data.name,
  );
}

function* invokeMeetingShortcutDelete(action: types.IMeetingShortcutDelete) {
  yield call(services.meetingShortcutDelete, action.payload.shortcutId, action.payload.meetingId);
}

export function* watchMeetingDashboardPageSaga() {
  yield takeLatest(constants.INITIAL_MEETING_DASHBOARD_PAGE, invokeInitialMeetingDashboard);
  yield takeLatest(
    constants.MEETING_SHORTCUT_CREATE_FOLDER_MEETING_DASHBOARD_PAGE,
    invokeTeamFileCreateFolderMeetingDashboardPage,
  );
  yield takeLatest(
    constants.MEETING_SHORTCUT_SELECTED_FOLDER_MEETING_DASHBOARD_PAGE,
    invokeMeetingShortcutSelectedFolderMeetingDashboardPage,
  );

  yield takeLatest(constants.MEETING_SHORTCUT_DELETE_FILE_MEETING_DASHBOARD_PAGE, invokeTeamFileDeleteFileDashboard);
  yield takeLatest(constants.MEETING_SHORTCUT_CREATE_FILE_MEETING_DASHBOARD_PAGE, invokeTeamFileCreateFileDashboard);
  yield takeLatest(
    constants.MEETING_SHORTCUT_UNSELECTED_FOLDER_MEETING_DASHBOARD_PAGE,
    invokeTeamFileOnDeselectFolderMeetingDashboardPage,
  );
  yield takeLatest(constants.MEETING_SHORTCUT_UPDATE_PAGE, invokeMeetingShortcutUpdate);
  yield takeLatest(constants.MEETING_SHORTCUT_DELETE_PAGE, invokeMeetingShortcutDelete);
}
